import { agentConstants, globalConstants } from "../../constants";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import { agentService } from "../../services";
import { customToast } from "../../shared/utility";
import { custom, success } from "./utilities";

const { GET_AGENT_LISTING, AGENT_DETAILS } = agentConstants;

const getAgentListing = (id, body) => (dispatch) => {
  dispatch(custom(GET_AGENT_LISTING, globalConstants.SPINNER_ACTIVATE));
  agentService
    .getAgentListing(id, body)
    .then(
      (response) => {
        dispatch(success(response.data, GET_AGENT_LISTING));
      },
      (error) => {}
    )
    .finally(() =>
      dispatch(custom(GET_AGENT_LISTING, globalConstants.SPINNER_DIACTIVATE))
    );
};

const updateAgentProfile = (data, successFunc) => {
  return (dispatch) => {
    dispatch(custom(AGENT_DETAILS, globalConstants.SPINNER_ACTIVATE));
    agentService
      .updateAgentProfile(data)
      .then(
        (response) => {
          customToast(response.msg, SUCCESS_TOAST);
          successFunc();
        },
        (error) => customToast(error[0], ERROR_TOAST)
      )
      .finally(() =>
        dispatch(custom(AGENT_DETAILS, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

const reSubmitApprovalRequest = (id, successFunc) => {
  return (dispatch) => {
    agentService.reSubmitApprovalRequest(id).then(
      (response) => {
        customToast(response.msg, SUCCESS_TOAST);
        successFunc();
      },
      (error) => customToast(error[0], ERROR_TOAST)
    );
  };
};
const giveAgentRating = (data, successFunc) => {
  return (dispatch) => {
    agentService.giveAgentRating(data).then(
      (response) => {
        customToast(response.msg, SUCCESS_TOAST);
        successFunc();
      },
      (error) => customToast(error[0], ERROR_TOAST)
    );
  };
};

export const agentActions = {
  getAgentListing,
  updateAgentProfile,
  reSubmitApprovalRequest,
  giveAgentRating,
};
